import withSubmittableForm from 'src/decorators/withSubmittableForm';
import moment from 'moment';
import { validDriverLicence } from './DriverLicenceFields';
import {
  submitIdentityVerificationForm as submitIdentityVerificationFormAction,
  submitMinorIdentityVerificationForm as submitMinorIdentityVerificationFormAction,
  submitSmsfIdentityVerificationForm as submitSmsfIdentityVerificationFormAction,
  submitAdvisorIdentityVerificationForm as submitAdvisorIdentityVerificationFormAction,
  identityVerificationFormErrorsCleared as identityVerificationFormErrorsClearedAction,
} from 'scripts/redux/actions/registration';
import { userSelector } from 'scripts/redux/actions/user';
import {
  identityVerificationFormErrorsSelector,
  identityVerificationFormSubmittingSelector,
} from 'src/store/identityVerificationFormReducer';
import IdentityVerificationForm from 'src/components/oldOnboarding/identityVerification/IdentityVerificationForm';
import { ACCOUNTTYPES } from 'src/settings/registration';

export default withSubmittableForm({
  Form: IdentityVerificationForm,
  mapStateToProps: (state) => ({
    ...userSelector(state),
    ...identityVerificationFormErrorsSelector(state),
    ...identityVerificationFormSubmittingSelector(state),
  }),
  mapDispatchToProps: {
    submitIdentityVerificationForm: submitIdentityVerificationFormAction,
    submitMinorIdentityVerificationForm: submitMinorIdentityVerificationFormAction,
    submitSmsfIdentityVerificationForm: submitSmsfIdentityVerificationFormAction,
    submitAdvisorIdentityVerificationForm: submitAdvisorIdentityVerificationFormAction,
    identityVerificationFormErrorsCleared: identityVerificationFormErrorsClearedAction,
  },
  mapPropsToInitialFormValues: ({ user }) => ({
    givenName: user.givenName,
    middleName: '',
    licenceNumber: '',
    licenceCardNumber: '',
    licenceState: '',
    familyName: '',
    address: '',
    mobilePhone: '',
    usCitizen: '',
    tfn: '',
    isWholesale: false,
    certificateExpired: null,
    certificate: null,
    certificateLabel: null,
    questionnaire: JSON.stringify({}),
  }),
  onSubmit: ({ formValues, props }) => {
    if (!validDriverLicence(formValues)) return undefined;
    const {
      submitIdentityVerificationForm,
      submitMinorIdentityVerificationForm,
      submitSmsfIdentityVerificationForm,
      submitAdvisorIdentityVerificationForm,
      user,
    } = props;
    const {
      dayOfBirth,
      monthOfBirth,
      yearOfBirth,
      certificateExpired,
      licenceNumber,
      licenceCardNumber,
      licenceState,
      ...personalValues
    } = formValues;
    const otherFormValues = {
      ...personalValues,
      licence: { licenceNumber: licenceNumber.trim(), licenceCardNumber: licenceCardNumber.trim(), licenceState },
    };
    if (user.accountType === ACCOUNTTYPES.MINOR.toUpperCase()) {
      const formData = {
        id: user.id,
        dateOfBirth: moment({
          year: yearOfBirth,
          month: monthOfBirth - 1,
          day: dayOfBirth,
        }).format('DD-MM-YYYY'),
        minorDateOfBirth: moment({
          year: formValues.minorYearOfBirth,
          month: formValues.minorMonthOfBirth - 1,
          day: formValues.minorDayOfBirth,
        }).format('DD-MM-YYYY'),
        australianTaxResidency: true,
        ...otherFormValues,
      };
      return submitMinorIdentityVerificationForm(formData);
    }
    if (
      user.accountType === ACCOUNTTYPES.SMSF.toUpperCase() ||
      user.accountType === ACCOUNTTYPES.TRUST.toUpperCase() ||
      user.accountType === ACCOUNTTYPES.CORPORATION.toUpperCase()
    ) {
      const formData = {
        id: user.id,
        dateOfBirth: moment({
          year: yearOfBirth,
          month: monthOfBirth - 1,
          day: dayOfBirth,
        }).format('DD-MM-YYYY'),
        australianTaxResidency: true,
        ...otherFormValues,
      };
      return submitSmsfIdentityVerificationForm(formData);
    }
    if (user.accountType === ACCOUNTTYPES.ADVISOR.toUpperCase()) {
      const formData = {
        id: user.id,
        dateOfBirth: moment({
          year: yearOfBirth,
          month: monthOfBirth - 1,
          day: dayOfBirth,
        }).format('DD-MM-YYYY'),
        australianTaxResidency: true,
        ...otherFormValues,
      };
      return submitAdvisorIdentityVerificationForm(formData);
    }
    const formData = {
      id: user.id,
      dateOfBirth: moment({
        year: yearOfBirth,
        month: monthOfBirth - 1,
        day: dayOfBirth,
      }).format('DD-MM-YYYY'),
      australianTaxResidency: true,
      certificateExpired: '01-01-2099',
      ...otherFormValues,
    };
    return submitIdentityVerificationForm(formData);
  },
});
